import moment from 'moment-timezone'

export function applyModifier (day, modifier) {
    const m = moment(day)
    if (!modifier) {
        return false
    }

    if (modifier instanceof Date) {
        return m.isSame(moment(modifier))
    }

    if (modifier.from && modifier.to) {
        // NOTE: from and to are inclusive
        return m.isBetween(moment(modifier.from), moment(modifier.to), '[]')
    }

    if (modifier.before && modifier.after) {
        return m.isBefore(moment(modifier.before)) && m.isAfter(moment(modifier.after))
    }

    if (modifier.before) {
        return m.isBefore(moment(modifier.before))
    }

    if (modifier.after) {
        return m.isAfter(moment(modifier.after))
    }

    return false
}
